var _path, _rect, _g, _rect2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMcfAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.553 448H361.428L389.045 368H410.842L438.42 448H420.295L400.256 386.281H399.631L379.553 448ZM378.42 416.555H421.232V429.758H378.42V416.555ZM464.963 368V448H448.049V368H464.963Z",
    fill: "url(#paint0_linear_2521_28696)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2521_28696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2521_28696)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.933 441.867C247.022 445.956 252.089 448 258.133 448C260.978 448 263.467 447.644 265.6 446.933C267.733 446.222 270.222 444.444 273.067 441.6L450.667 263.467C456.711 257.422 461.333 250.756 464.533 243.467C467.733 236.178 469.333 228.978 469.333 221.867C469.333 211.556 467.822 202.489 464.8 194.667C461.778 186.844 457.067 179.733 450.667 173.333L360.533 82.6667C354.133 76.2667 347.022 71.5556 339.2 68.5333C331.378 65.5111 322.844 64 313.6 64C306.133 64 298.667 65.5111 291.2 68.5333C283.733 71.5556 276.978 75.9111 270.933 81.6L366.4 177.067C371.022 181.689 374.222 186.667 376 192C377.778 197.333 378.667 202.489 378.667 207.467C378.667 219.911 374.4 230.133 365.867 238.133C357.333 246.133 347.378 250.133 336 250.133C330.667 250.133 325.333 248.978 320 246.667C314.667 244.356 310.044 241.244 306.133 237.333L226.133 156.8L107.2 275.733C105.067 277.867 103.467 280.178 102.4 282.667C101.333 285.156 100.8 287.822 100.8 290.667C100.8 296.711 102.844 301.778 106.933 305.867C111.022 309.956 116.089 312 122.133 312C125.689 312 128.711 311.467 131.2 310.4C133.689 309.333 135.822 307.911 137.6 306.133L235.733 207.467L251.2 222.4L152.533 321.067C150.4 323.2 148.8 325.511 147.733 328C146.667 330.489 146.133 333.156 146.133 336C146.133 341.689 148.267 346.667 152.533 350.933C156.8 355.2 161.778 357.333 167.467 357.333C170.667 357.333 173.511 356.8 176 355.733C178.489 354.667 180.8 353.067 182.933 350.933L281.6 252.8L296.533 267.733L197.867 366.4C196.089 368.178 194.667 370.222 193.6 372.533C192.533 374.844 192 377.778 192 381.333C192 387.378 194.044 392.444 198.133 396.533C202.222 400.622 207.289 402.667 213.333 402.667C216.178 402.667 218.844 402.133 221.333 401.067C223.822 400 226.133 398.4 228.267 396.267L326.4 297.6L341.867 313.067L243.2 411.733C241.067 413.867 239.467 416.267 238.4 418.933C237.333 421.6 236.8 424.178 236.8 426.667C236.8 432.711 238.844 437.778 242.933 441.867Z",
    fill: "url(#paint1_linear_2521_28696)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2521_28696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 512,
    height: 512
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2521_28696)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3333 263.467L75.2 277.333L225.6 126.933L321.6 221.867C324.089 224.356 326.4 226.044 328.533 226.933C330.667 227.822 333.333 228.267 336.533 228.267C342.222 228.267 347.2 226.133 351.467 221.867C355.733 217.6 357.867 212.622 357.867 206.933C357.867 204.089 357.333 201.422 356.267 198.933C355.2 196.444 353.6 194.133 351.467 192L242.133 82.6667C235.022 75.5556 227.733 70.6667 220.267 68C212.8 65.3333 204.267 64 194.667 64C187.2 64 179.556 65.6889 171.733 69.0667C163.911 72.4444 157.156 76.9778 151.467 82.6667L61.3333 173.333C56 178.667 51.5555 185.244 48 193.067C44.4444 200.889 42.6666 209.422 42.6666 218.667C42.6666 227.2 44.2666 235.378 47.4666 243.2C50.6666 251.022 55.2888 257.778 61.3333 263.467Z",
    fill: "url(#paint2_linear_2521_28696)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2521_28696",
    x1: 431.082,
    y1: 367.651,
    x2: 383.383,
    y2: 379.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C459C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEAE54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DFC316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#35B0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D62D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2521_28696",
    x1: 405.333,
    y1: 138.667,
    x2: 181.333,
    y2: 362.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC58CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#DE5F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F56C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FA8D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2521_28696",
    x1: 362.667,
    y1: 202.667,
    x2: 64,
    y2: 266.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#106EDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#0C5CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#35B0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#41AC8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#95B84D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFC316"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcfAi);
export default __webpack_public_path__ + "static/media/mcf-ai.93e674b4da5c808efd7ab24e1334b27d.svg";
export { ForwardRef as ReactComponent };